import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IconType } from '../../../../../../../libs/Shared/components/icon/icon';

@Component({
  selector: 'app-star',
  templateUrl: './star.component.html',
  standalone: false,
})
export class StarComponent {
  @Input() recordId: string | undefined;
  @Input() selected: boolean = false;
  @Output() starSelected = new EventEmitter<string>();
  @Output() starDeselected = new EventEmitter<string>();

  IconType = IconType;

  star_click() {
    this.selected = !this.selected;

    if (this.selected) {
      this.starSelected.emit(this.recordId);
    } else {
      this.starDeselected.emit(this.recordId);
    }
  }
}
